<script>
export default {
  data () {
    return {
      token: '',
    }
  },
  mounted() {
    this.token = this.$route.query.token;
    localStorage.setItem('token', this.$route.query.token)
    this.$http.get('upms/User/getUserInfo').then(res =>{
      localStorage.setItem('token', this.token)
      localStorage.setItem('userId', res.result.userId)
      localStorage.setItem('nikeName', res.result.nikeName)
      localStorage.setItem('linkPohone', res.result.linkPohone)
      this.$router.push('/home')
    })
  }
}

function getQueryFramId() {

  var loc = window.location.search;
  var n1 = loc.length;//地址的总长度
  var n3 = loc.split("farmId=")[1];//取得=号的位置
  // console.log(n2)
  // var n3 = loc.substr(n2 + 1, n1 - n2);//从=号后面的内容
  if(n3){
    return  n3
  }else{
    return ''
  }
}

function getQueryString(name) {

  var loc = window.location.search;
  var n3 = loc.split("token=")[1];//取得=号的位置
  if(n3.length!=0){
    return  n3
  }else{
    return localStorage.getItem('token')
  }
}

</script>

<template>
  <div>

  </div>
</template>

<style scoped>

</style>
